import { createStore } from 'vuex'
import core from './modules/core'
//import ystore from './modules/ystore'
//import firestore from './modules/firestore'

export default createStore({
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    core
    //, ystore
    //firestore
  }
})
